import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import store from '../store'
import { recordPageInAnalytics } from 'vue-common'
import { authGuard } from '@/gaurds/auth.guard'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/folders'
  },
  {
    path: '/folders',
    name: 'Folders',
    meta: {
      breadcrumbs: [
        {
          text: 'Shared Folders',
          to: '/folders'
        }
      ]
    },
    // route level code-splitting
    // this generates a separate chunk (folders.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "folders" */ '../views/Folders.vue')
  },
  {
    path: '/folders/:id',
    name: 'Folder',
    meta: {
      breadcrumbs: [
        {
          text: 'Shared Folders',
          to: '/folders'
        },
        {
          text: ':name',
          to: ''
        }
      ]
    },
    // route level code-splitting
    // this generates a separate chunk (folder.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "folders" */ '../views/Folder.vue')
  },
  {
    path: '/folders/:id/techpack/:techpackId',
    name: 'InlineTechpack',
    component: () => import(/* webpackChunkName: "inline techpack" */ '../views/Techpack.vue'),
    // if the user refreshes the page while viewing a techpack, or shares a link to the techpack, we
    // have to ensure we have the necessary data to render the techpack before the component renders.
    beforeEnter: async (to, from, next) => {
      if (!store.getters['sharedFolders/hasTechpacks']) {
        const folderId = to.params.id
        await store.dispatch('sharedFolders/getSharedFolder', folderId)
        await store.dispatch('sharedFolders/getSharedTechpacks', folderId)
        next()
      }
      next()
    },
    meta: {
      breadcrumbs: [
        {
          text: 'Shared Folders',
          to: '/folders'
        },
        {
          text: ':name',
          to: '/folders/:id'
        },
        {
          text: ':techpackName',
          to: ''
        }
      ]
    }
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "folders" */ '../components/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(authGuard)

/**
 * record page visit in segment
 */
router.afterEach(recordPageInAnalytics)

export default router
